import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from 'syf-component-library/ui/spacing/Inset';
import { StyledContainer } from '../../../../styles/common';
import InfoHeader from '../../../common/info-header';
import useDeviceWidth from '../../../../hooks/use-device-width';
var ExtraInfoSkeleton = function (_a) {
    var currentTransaction = _a.currentTransaction, type = _a.type, children = _a.children;
    var isMobile = useDeviceWidth();
    var status = currentTransaction.status, description = currentTransaction.description;
    var transactionDescription = description !== null && description !== void 0 ? description : type;
    var spacing = isMobile ? 'base' : 'large';
    return (_jsxs(StyledContainer, { children: [_jsx(InfoHeader, { status: status, iconType: type, description: transactionDescription }), _jsx(Inset, { vertical: spacing, top: spacing, children: children })] }));
};
export default ExtraInfoSkeleton;
//# sourceMappingURL=index.js.map